export default __webpack_public_path__ + "static/media/Genrationoftoday.e07e8730.webp";